module.exports = __webpack_public_path__ + "img/arrow-left-icon.30e9ff09.svg";